import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import BM10100View from "../../Views/Bases/BM10100";
import Snackbar from "../../Components/Snackbar";

function BM10100(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [checkInputs, setCheckInputs] = React.useState({
    processCd: "PRO003",
    processNm: "",
    machineCd: "",
    comboProcessCd: [],
    result: false,
  });
  const [saveData, setSaveData] = React.useState([]);

  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (
        e.message === "ResizeObserver loop limit exceeded" ||
        e.message ===
          "ResizeObserver loop completed with undelivered notifications."
      ) {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    Init();
  }, []);

  const Init = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let getComboData = [];
    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
      //콤보박스
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetProc,
        {
          processCd: "string",
        }
      ).then((result) => {
        let data = result.data;
        getComboData.push({
          value: "",
          name: "선택해주세요",
        });
        for (let i = 0; i < data.length; i++) {
          getComboData.push({
            value: data[i].value,
            name: data[i].name,
          });
        }
        checkInputs.comboProcessCd = getComboData;
        // checkInputs.comboProcessCd = getComboData.filter(
        //   (e) => e.groupCd == "PLANT_CD" && e.value != "PLANT_CD"
        // );
      });
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10100.GetMachine
      ).then((result) => {
        let data = result.data;
        if (data == "데이터가 없습니다.") {
          setRowData([]);
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              processCd: data[i].processCd,
              processNm: data[i].processNm,
              machineCd: data[i].machineCd,
              machineNm: data[i].machineNm,
              createDate: data[i].createDate
                ? Commons.DateFormating(data[i].createDate.toString(), 2)
                : "",
              createId: data[i].createId,
              updateDate: data[i].updateDate
                ? Commons.DateFormating(data[i].updateDate.toString(), 2)
                : "",
              updateId: data[i].updateId,
            });
          }
          setRowData(getRowData);
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const CheckKeys = async () => {
    Dialog.ProgressBar(true);

    if (checkInputs.machineCd === "") {
      setSnackbars({
        toggle: true,
        type: "info",
        message: "설비코드를 입력해주세요.",
      });
      Dialog.ProgressBar(false);
      return;
    }
    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10100.CheckCode,
        {
          processCd: checkInputs.processCd,
          machineCd: checkInputs.machineCd,
        }
      ).then((result) => {
        let data = result.data;

        if (data) {
          setCheckInputs({
            ...checkInputs,
            result: data,
          });
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_UseokCode" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          setCheckInputs({
            ...checkInputs,
            processCd: "",
          });
          setSnackbars({
            toggle: true,
            type: "error",
            message: lanData.filter(
              (f) => f.lanId === "Snack_UsenoCode" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const Print = async (e) => {
    let headerData = [];
    let tableData = [];
    let address;

    //var ItemInfo = itemList.find(f => f.ItemCd == viewModel.DataItem.ItemCd);

    //address = "http://114.206.84.134:5540/Bases/Process_BarCode"; //http://localhost:65061/ 114.206.84.134:5540
    address = "https://dongsungprintingmes.com:8082/Bases/Process_BarCode"; //http://localhost:65061/ 114.206.84.134:5540

    headerData.push({
      ReportTitle: "공정 바코드",
      ProcessCd: e.data.processCd,
    });

    var f = document.createElement("form");
    f.action = address; //192.168.10.252:8081  //192.168.254.33:8081
    f.method = "POST";
    f.target = "_blank";

    var k = document.createElement("input");
    k.type = "hidden";
    k.name = "headerData";
    k.value = JSON.stringify(headerData);
    f.append(k);

    var l = document.createElement("input");
    l.type = "hidden";
    l.name = "tableData";
    l.value = JSON.stringify(tableData);
    f.append(l);
    document.body.appendChild(f);
    f.submit();
  };

  const SaveConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        SaveLogic();
      }
    );
  };

  const SaveLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    let updateData = Commons.Deduplication(changedRowData);
    let getData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      if (!updateData[0]) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: lanData.filter(
            (f) =>
              f.lanId === "Snack_EnterFacilityName" && f.lanType === "SNACK"
          )[0].lanName,
        });
        return false;
      }
      for (let i = 0; i < updateData.length; i++) {
        getData.push({
          processCd: updateData[i].processCd,
          machineCd: updateData[i].machineCd,
          machineNm: updateData[i].machineNm,
          createId: userInfo.userId,
          updateId: userInfo.userId,
        });
      }
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10100.Create,
        getData
      ).then((result) => {
        let data = result.data;

        if (data !== "Ok") {
          throw new Error(data.message);
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          Init();
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
      setChangedRowData([]);
    }
  };

  const DeleteConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        DeleteLogic();
      }
    );
  };

  const DeleteLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = {};
    let tranData = [];

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });

      for (let i = 0; i < selectedRowData.length; i++) {
        tranData.push({
          processCd: selectedRowData[i].processCd,
          machineCd: selectedRowData[i].machineCd,
        });
      }

      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10100.Delete,
        tranData
      ).then((result) => {
        let data = result.data;

        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
        } else {
          Init();
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Delete" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  return (
    <>
      <BM10100View
        Init={Init}
        lanData={lanData}
        rowData={rowData}
        setRowData={setRowData}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        setSelectedRowData={setSelectedRowData}
        SaveConfirm={SaveConfirm}
        DeleteConfirm={DeleteConfirm}
        checkInputs={checkInputs}
        setCheckInputs={setCheckInputs}
        CheckKeys={CheckKeys}
        setSnackbars={setSnackbars}
        setSaveData={setSaveData}
        saveData={saveData}
        Print={Print}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default BM10100;
